import styled, { css } from 'styled-components';
import { colors, getScrollBarStyles } from '../../../config/styles';
import { isNil } from 'lodash';
import { theme } from '../../../styles/theme';
import {
  floatingComponentStyles,
  optionHover,
  overflowingStyles,
} from '../../../styles/shareableStyles';

const PANEL_WIDTH = 240;
const PANEL_HEIGHT = 280;

const disabledCss = css`
  opacity: 0.5;
  pointer-events: none;
`;

export const PanelWrapper = styled.div`
  height: ${PANEL_HEIGHT}px;
  min-width: ${PANEL_WIDTH}px;
  display: flex;
  flex-direction: column;
  color: ${theme.colors.secondary800};
  font-weight: 500;
  ${floatingComponentStyles};
`;

export const PanelRow = styled.div<{ $disabled: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow-y: auto;

  ${({ $disabled }) => ($disabled ? disabledCss : undefined)}
`;

export const ScrollableCol = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  ${getScrollBarStyles(2)};
`;

export const MenuColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${theme.colors.border};
  width: ${PANEL_WIDTH}px;
`;

export const MenuCol = styled(ScrollableCol)`
  flex: 1;
`;

export const DetailsCol = styled.div`
  padding: 12px;
  width: ${PANEL_WIDTH}px;
  display: flex;
  gap: 12px;
`;

export const Node = styled.div`
  display: flex;
  min-height: 28px;
  user-select: none;
  padding: 0 4px 0 8px;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const NodeWithName = styled(Node)<{
  $selected?: boolean;
  $disabled?: boolean;
  $indent?: number;
}>`
  min-height: 28px;
  user-select: none;
  padding: 0 4px 0 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  ${({ $disabled }) => ($disabled ? disabledCss : undefined)}

  margin-left: ${({ $indent }) => (!isNil($indent) ? $indent * 8 : 0)}px;

  ${({ $selected }) => $selected && optionHover}

  &:hover {
    background-color: ${theme.colors.blue500};
    cursor: pointer;
  }
`;

export const NodeWithCount = styled(NodeWithName)`
  gap: 4px;
`;

export const NodeDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const NodeDetailsHeader = styled.div`
  display: flex;
  column-gap: 8px;
  cursor: pointer;
`;

export const NodeDetailsMain = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  flex: 1;
  max-height: 100%;
  overflow-y: auto;
  ${getScrollBarStyles(2)};
  margin-right: -12px;
  padding-right: 12px;
`;

export const NodeDetailsFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: 8px;
`;

export const DetailsDescription = styled.div`
  font-size: 10px;
  line-height: 1.5;
  color: ${theme.colors.secondary600};
  word-break: break-word;
`;

export const DescriptionBlock = styled.div``;

export const DescriptionTerm = styled.div`
  font-size: 10px;
  color: ${theme.colors.secondary800};
`;

export const EntityMenuName = styled.div`
  flex: 1;
  ${overflowingStyles};
`;

export const EntityTitle = styled.div`
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
  word-break: break-word;
`;

export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CenterContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const NestedFieldDetailsForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`;

export const ActionRow = styled.div`
  margin-top: 4px;
  text-align: right;
`;

// see at usage side why this is a <button>
export const WidgetButtonWrapper = styled.button`
  font-size: inherit;
  font-family: inherit;
  text-align: inherit;
`;

export const ErrorMessageRow = styled.div`
  color: ${colors.mainError};
  line-height: 1.2;
`;
